(() => {
  const header = document.querySelector('sticky-header');
  if (!header) return;
  let lastY = window.scrollY;
  let ticking = false;

  const isLocked = () =>
    document.body.classList.contains('overflow-hidden') ||
    header.matches(':focus-within') ||
    header.querySelector('[open], [aria-expanded="true"]');

  const update = () => {
    const y = window.scrollY;
    const delta = y - lastY;
    header.classList.toggle('velora-header--scrolled', y > 24);
    if (!isLocked() && y > 180 && Math.abs(delta) > 8) {
      header.classList.toggle('velora-header--hidden', delta > 0);
    } else if (y <= 180 || isLocked()) {
      header.classList.remove('velora-header--hidden');
    }
    lastY = y;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
})();
